const publishPageEvent = (eventName, payload = {}) => {
  const safePayload = {
    page_template: document.querySelector('main[data-template]')?.dataset.template || '',
    ...payload
  };

  document.dispatchEvent(new CustomEvent('lunqo:analytics', {
    detail: { event: eventName, payload: safePayload }
  }));
  window.dataLayer?.push({ event: eventName, ...safePayload });
  window.Shopify?.analytics?.publish?.(eventName, safePayload);
};

class LunqoFaqSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-lq-faq-search]');
    this.items = [...this.querySelectorAll('[data-lq-faq-item]')];
    this.groups = [...this.querySelectorAll('[data-lq-faq-group]')];
    this.status = this.querySelector('[data-lq-faq-status]');
    this.abortController?.abort();
    this.abortController = new AbortController();

    this.input?.addEventListener('input', () => this.filter(), {
      signal: this.abortController.signal
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  filter() {
    const query = this.input.value.trim().toLocaleLowerCase();
    let visible = 0;

    this.items.forEach((item) => {
      const matches = query === '' || item.textContent.toLocaleLowerCase().includes(query);
      item.hidden = !matches;
      if (matches) visible += 1;
    });

    this.groups.forEach((group) => {
      const category = group.dataset.lqFaqGroup;
      const hasVisibleItems = this.items.some((item) => (
        item.dataset.lqFaqCategory === category && !item.hidden
      ));
      group.hidden = !hasVisibleItems;
    });

    if (this.status) {
      const template = visible === 1
        ? this.status.dataset.resultSingular
        : this.status.dataset.resultPlural;
      this.status.textContent = template.replace('[count]', visible);
    }
  }
}

if (!customElements.get('lunqo-faq-search')) {
  customElements.define('lunqo-faq-search', LunqoFaqSearch);
}

if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('.lq-page-system video[autoplay]').forEach((video) => {
    video.pause();
  });
}

const labelAppIframes = (root = document) => {
  const selector = 'main iframe:not([title]), main iframe[title=""]';
  const iframes = [
    ...(root.matches?.(selector) ? [root] : []),
    ...(root.querySelectorAll?.(selector) || [])
  ];

  iframes.forEach((iframe) => {
    const isAffiliateApplication = iframe.src.includes('uppromote');
    iframe.title = isAffiliateApplication
      ? 'LUNQO affiliate program application'
      : 'LUNQO embedded application form';
  });
};

labelAppIframes();

const appIframeObserver = new MutationObserver((mutations) => {
  mutations.forEach(({ addedNodes }) => {
    addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) labelAppIframes(node);
    });
  });
});

appIframeObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener('click', (event) => {
  const target = event.target.closest('[data-lq-event]');
  if (!target) return;

  publishPageEvent(target.dataset.lqEvent, {
    section_id: target.closest('[data-lq-section-id]')?.dataset.lqSectionId || '',
    action_label: target.dataset.lqEventLabel || target.textContent.trim().slice(0, 80)
  });
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('.lq-page-form');
  if (!form) return;

  const submitButton = form.querySelector('[type="submit"]');
  const formType = form.querySelector('[name="contact[Form type]"]')?.value || 'contact';
  submitButton?.setAttribute('aria-busy', 'true');
  publishPageEvent('lunqo_form_submit', {
    form_type: formType
  });
});

document.querySelectorAll('[data-lq-form-success]').forEach((success) => {
  const key = `lunqo-form-success:${location.pathname}:${success.dataset.lqFormSuccess}`;
  if (sessionStorage.getItem(key)) return;

  sessionStorage.setItem(key, '1');
  publishPageEvent('lunqo_form_success', {
    form_type: success.dataset.lqFormSuccess
  });
});
